<template>
	<div class="detail flex1">
		<div class="header colFFF f-a">
			<div class="pointer" @click="back">
				<i class="el-icon-arrow-left " ></i>
				<span class="mL10">{{title}}</span>
			</div>
		</div>
		<div class="list  ">
			<img :src="item" alt="" v-for="(item,index) in list"/>
		</div>
	</div>
</template>

<script>
	import { category_list } from '@/data/data.js';
	export default {
		data() {
			return {
				list:[],
				title:''
			};
		},
		created() {
			let id=this.$route.params.id
			category_list.forEach((item1,index1)=>{
				item1.list.forEach((item2)=>{
					
					if(item2.id==id){
						this.$parent.tabs_index=index1
						this.list=item2.list
						this.title=item2.title
					}
				})
			})
		},
		methods:{
			back(){
				this.$router.back()
			}
		}
	};
</script>

<style lang="less" scoped>
.detail {
	padding-top: 0;
	box-sizing: border-box;
	.header {
		line-height: 56px;
		height: 56px;
		text-indent: 10px;
		background-color: #b3c0d1;
	}
	.list {
		img {
			display: block;
			width: 50%;
			margin: 0 auto;
		}
	}
}
</style>